let books : any = {
    Matthew: { abbreviatedBook: "41-MAT", numChapters: 28},
    Mark: { abbreviatedBook: "42-MRK", numChapters: 16},
    Luke: { abbreviatedBook: "43-LUK", numChapters: 24},
    John: { abbreviatedBook: "44-JHN", numChapters: 21},
    Acts: { abbreviatedBook: "45-ACT", numChapters: 28},
    Romans: { abbreviatedBook: "46-ROM", numChapters: 16},
    "1 Corinthians": { abbreviatedBook: "47-1CO", numChapters: 16},
    "2 Corinthians": { abbreviatedBook: "48-2CO", numChapters: 13},
    Galatians:  { abbreviatedBook: "49-GAL", numChapters: 6},
    Ephesians:  { abbreviatedBook: "50-EPH", numChapters: 6},
    Philippians:  { abbreviatedBook: "51-PHP", numChapters: 4},
    Colossians: { abbreviatedBook: "52-COL", numChapters: 4},
    "1 Thessalonians": { abbreviatedBook: "53-1TH", numChapters: 5},
    "2 Thessalonians": { abbreviatedBook: "54-2TH", numChapters: 3},
    "1 Timothy": { abbreviatedBook: "55-1TI", numChapters: 6},
    "2 Timothy": { abbreviatedBook: "56-2TI", numChapters: 4},
    "Titus": {abbreviatedBook: "57-TIT", numChapters: 3},
    Philemon: { abbreviatedBook: "58-PHM", numChapters: 1},
    Hebrews: { abbreviatedBook: "59-HEB", numChapters: 13},
    James: { abbreviatedBook: "60-JAS", numChapters: 5},
    "1 Peter": { abbreviatedBook: "61-1PE", numChapters: 5},
    "2 Peter": { abbreviatedBook: "62-2PE", numChapters: 3},
    "1 John": { abbreviatedBook: "63-1JN", numChapters: 5},
    "2 John": { abbreviatedBook: "64-2JN", numChapters: 1},
    "3 John": { abbreviatedBook: "65-3JN", numChapters: 1},
    Jude: { abbreviatedBook: "66-JUD", numChapters: 1},
    Revelation: { abbreviatedBook: "67-REV", numChapters: 22},
}

export {books};